import { spawn } from 'redux-saga/effects';

import { sagas as oneTimeDetailsSagas } from './oneTimeDetailsModule';

export default function* sagas() {
	yield spawn(oneTimeDetailsSagas);
}
